import React, { useState } from "react";
import VoiceChatUI from "./VoiceChatUI";
import { useDispatch } from "react-redux";
import { setShowChatLogo } from "../../redux/animationSlice";

const VoiceChat = ({
  saveConversation,
  setSaveConversation,
  conversationHistory,
  setConversationHistory, // Props for persistence
}) => {
  const [userMessage, setUserMessage] = useState("");
  const dispatch = useDispatch();

  // Called after sending a user message
  const sendMessage = async (message) => {
    dispatch(setShowChatLogo(true));
  };

  return (
    <VoiceChatUI
      conversationHistory={conversationHistory} // Pass down
      setConversationHistory={setConversationHistory} // Pass down
      userMessage={userMessage}
      setUserMessage={setUserMessage}
      sendMessage={sendMessage}
      saveConversation={saveConversation}
      setSaveConversation={setSaveConversation}
    />
  );
};

export default VoiceChat;
